import { motion, useReducedMotion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { FondoVideoAmbient } from "../../shared";
import Ornamento from "./Ornamento";

export default function Portada({ datos }) {
  const { pareja, evento, fotos } = datos;
  const reduce = useReducedMotion();
  const conVideo = Boolean(datos.portadaVideo?.urlYoutube);
  const entrar = (delay) => ({
    initial: { opacity: 0, y: reduce ? 0 : 22 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 1, delay, ease: [0.22, 1, 0.36, 1] },
  });

  return (
    <header className={`ba-portada${conVideo ? " ba-portada--video" : ""}`} data-testid="ba-portada">
      {conVideo && (
        <>
          <FondoVideoAmbient
            urlYoutube={datos.portadaVideo.urlYoutube}
            poster={datos.portadaVideo.poster || fotos.portada}
          />
          <div className="ba-portada-velo" />
        </>
      )}
      <span className="ba-portada-lateral ba-portada-lateral--izq">{evento.fechaLegible}</span>
      <span className="ba-portada-lateral ba-portada-lateral--der">{evento.ciudad}</span>

      <motion.p className="ba-portada-frase" {...entrar(0.1)}>
        {pareja.fraseIntroductoria}
      </motion.p>
      <motion.h1 className="ba-portada-nombres" {...entrar(0.25)}>
        <span data-testid="ba-nombre-1">{pareja.nombre1}</span>
        <span className="ba-portada-y" aria-hidden="true">
          &
        </span>
        <span data-testid="ba-nombre-2">{pareja.nombre2}</span>
      </motion.h1>
      {!conVideo && (
        <motion.div className="ba-portada-fotomarco" {...entrar(0.4)}>
          <img
            className="ba-portada-foto"
            src={fotos.portada}
            alt={`Fotografía de ${pareja.nombre1} y ${pareja.nombre2}`}
          />
        </motion.div>
      )}
      <motion.div {...entrar(0.55)}>
        <Ornamento />
      </motion.div>
      <motion.p className="ba-portada-fecha" data-testid="ba-fecha" {...entrar(0.65)}>
        {evento.fechaLegible} · {evento.ciudad}
      </motion.p>
      <motion.p className="ba-portada-mensaje" {...entrar(0.78)}>
        {pareja.mensajePortada}
      </motion.p>
      <motion.a
        href="#ba-contenido"
        className="ba-portada-bajar"
        aria-label="Desplazarse al contenido de la invitación"
        data-testid="ba-boton-bajar"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1.1 }}
      >
        <ChevronDown size={17} strokeWidth={1.5} />
      </motion.a>
    </header>
  );
}
